import { initContract } from '@ts-rest/core';
import { z } from 'zod';
const c = initContract();
// ── Consultant Update (with org's summary) ──
export const ConsultantUpdateItemSchema = z.object({
    id: z.string(),
    kind: z.string(),
    publicationDate: z.string(),
    // AI-generated summaries (global)
    shortSummary: z.string().nullable(),
    summary: z.string().nullable(),
    // Consultant org's summaries
    consultantShortSummary: z.string().nullable(),
    consultantSummary: z.string().nullable(),
    consultantFile: z
        .object({
        id: z.string(),
        name: z.string(),
    })
        .nullable(),
    // Reference info
    reference: z
        .object({
        id: z.string(),
        externalId: z.string(),
        title: z.string(),
        type: z.string().nullable(),
    })
        .nullable(),
    // Source info
    source: z
        .object({
        id: z.string(),
        title: z.string(),
        geography: z.string(),
        icon: z.string().nullable(),
        institutionGeographies: z.array(z.string()).optional(),
    })
        .nullable(),
    // Update metadata
    updateType: z.string().nullable(),
    articleUrl: z.string().nullable(),
    title: z.string().nullable(),
    materialUrl: z.string().nullable(),
});
export const ConsultantUpdateSummaryBodySchema = z.object({
    shortSummary: z.string().nullable(),
    summary: z.string().nullable(),
    fileId: z.string().nullable().optional(),
});
export const ConsultantWorkspaceItemSchema = z.object({
    id: z.string(),
    name: z.string(),
    uname: z.string(),
});
// ── Triage schemas ──
export const WorkspaceTriageStatusSchema = z.object({
    workspaceId: z.string(),
    workspaceName: z.string(),
    subscribed: z.boolean(),
    applicabilityStatus: z
        .enum(['to_review', 'applicable', 'not_applicable', 'out_of_scope'])
        .nullable(),
});
export const ConsultantTriageUpdateSchema = z.object({
    id: z.string(),
    publicationDate: z.string(),
    title: z.string().nullable(),
    kind: z.string(),
    updateType: z.string().nullable(),
    source: z
        .object({
        id: z.string(),
        title: z.string(),
    })
        .nullable(),
    workspaceTriage: z.array(WorkspaceTriageStatusSchema),
});
export const ConsultantTriageBodySchema = z.object({
    workspaceId: z.string(),
    status: z.enum(['applicable', 'not_applicable']),
});
// ── Contract ──
export const consultantContract = c.router({
    getOrg: {
        method: 'GET',
        path: '/consultant/:orgId',
        responses: {
            200: z.object({ id: z.string(), name: z.string() }),
            403: z.object({ message: z.string() }),
            404: z.object({ message: z.string() }),
        },
    },
    listWorkspaces: {
        method: 'GET',
        path: '/consultant/:orgId/workspaces',
        responses: {
            200: z.array(ConsultantWorkspaceItemSchema),
            403: z.object({ message: z.string() }),
        },
    },
    listUpdates: {
        method: 'GET',
        path: '/consultant/:orgId/updates',
        query: z.object({
            fromDate: z.string().optional(),
            toDate: z.string().optional(),
            source: z.string().optional(),
            geography: z.string().optional(),
            kind: z.string().optional(),
            documentType: z.string().optional(),
        }),
        responses: {
            200: z.array(ConsultantUpdateItemSchema),
            403: z.object({ message: z.string() }),
        },
    },
    upsertSummary: {
        method: 'PATCH',
        path: '/consultant/:orgId/updates/:updateId/summary',
        body: ConsultantUpdateSummaryBodySchema,
        responses: {
            200: z.object({ message: z.string() }),
            403: z.object({ message: z.string() }),
            404: z.object({ message: z.string() }),
        },
    },
    uploadAnalysisFile: {
        method: 'POST',
        path: '/consultant/:orgId/updates/:updateId/file',
        contentType: 'multipart/form-data',
        body: c.type(),
        responses: {
            200: z.object({
                fileId: z.string(),
                fileName: z.string(),
            }),
            403: z.object({ message: z.string() }),
            404: z.object({ message: z.string() }),
        },
    },
    deleteAnalysisFile: {
        method: 'DELETE',
        path: '/consultant/:orgId/updates/:updateId/file',
        body: c.type(),
        responses: {
            200: z.object({ message: z.string() }),
            403: z.object({ message: z.string() }),
            404: z.object({ message: z.string() }),
        },
    },
    listTriageUpdates: {
        method: 'GET',
        path: '/consultant/:orgId/triage',
        query: z.object({
            fromDate: z.string().optional(),
            toDate: z.string().optional(),
            source: z.string().optional(),
            geography: z.string().optional(),
            kind: z.string().optional(),
            documentType: z.string().optional(),
        }),
        responses: {
            200: z.array(ConsultantTriageUpdateSchema),
            403: z.object({ message: z.string() }),
        },
    },
    triageUpdate: {
        method: 'PATCH',
        path: '/consultant/:orgId/triage/:updateId',
        body: ConsultantTriageBodySchema,
        responses: {
            200: z.object({ message: z.string() }),
            400: z.object({ message: z.string() }),
            403: z.object({ message: z.string() }),
            404: z.object({ message: z.string() }),
        },
    },
});
//# sourceMappingURL=consultant.js.map